import {registerRoute as workbox_routing_registerRoute} from '/mnt/c/Users/alexa/Documents/code/Small-Dev-Talk/node_modules/workbox-routing/registerRoute.mjs';
import {ExpirationPlugin as workbox_expiration_ExpirationPlugin} from '/mnt/c/Users/alexa/Documents/code/Small-Dev-Talk/node_modules/workbox-expiration/ExpirationPlugin.mjs';
import {CacheFirst as workbox_strategies_CacheFirst} from '/mnt/c/Users/alexa/Documents/code/Small-Dev-Talk/node_modules/workbox-strategies/CacheFirst.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/mnt/c/Users/alexa/Documents/code/Small-Dev-Talk/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "../../src/articleArchive/articleData.json",
    "revision": "d109da2d401b6519568ae745236bcf6e"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-07_Ghostship/image1.jpg",
    "revision": "27dcfa9ecd0efd99b9df432879c08219"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-07_Ghostship/image10.jpg",
    "revision": "afe9afcca0f32a8976567d16cd988c85"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-07_Ghostship/image11.jpg",
    "revision": "8d9210ff1cb1a22a43010fa06295e0b7"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-07_Ghostship/image12.jpg",
    "revision": "087daa82594a5041a5f61ae899909f99"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-07_Ghostship/image2.jpg",
    "revision": "e52a795a738be47b86fd5a46c38752ef"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-07_Ghostship/image3.jpg",
    "revision": "bb151e1aa85b98eb23a5d098eecb961d"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-07_Ghostship/image4.jpg",
    "revision": "3cbe6c46e8bc384cae1823d75c78924d"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-07_Ghostship/image5.png",
    "revision": "def8648d4bee746deebeff24603e37ec"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-07_Ghostship/image6.jpg",
    "revision": "a743180627e5e421c310676294a1d5e7"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-07_Ghostship/image7.jpg",
    "revision": "7d896113d82eef58199f7b53e04ce414"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-07_Ghostship/image8.jpg",
    "revision": "fe2e019064f54af3a81007f0d6d61cdc"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-07_Ghostship/image9.jpg",
    "revision": "7ca083aaca86b6438beee09c2b35d071"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-09_Outworld/image1.jpg",
    "revision": "42316989cb3524a4a0b9b1539c18ffb9"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-09_Outworld/image2.jpg",
    "revision": "a269c955ae1e919560fc4ed3a8202a60"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-09_Outworld/image3.jpg",
    "revision": "16ddaf2bf7720d2102ca2550ed40093a"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-09_Outworld/image4.jpg",
    "revision": "463b92557e750b3e59e70ab79c37db2b"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-09_Outworld/image5.jpg",
    "revision": "da3db4e9f9a70d6818a3a808c23db5f2"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-17_Hello/image1.jpg",
    "revision": "f935347ae298343a9f8d8cbe065ee765"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-19_Vessel/image1.jpg",
    "revision": "1a312289757ff487438359521def9550"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-19_Vessel/image2.jpg",
    "revision": "b95583b7e8856b83fb7428623c353a81"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-19_Vessel/image3.jpg",
    "revision": "59431aa1577fe958ab19994156ff1025"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-19_Vessel/image4.jpg",
    "revision": "c531ca2589e869827254619aba3f0b98"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-20_Shadowlurker/image1.jpg",
    "revision": "1e8b13c9e625916dd7a50e584c431662"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-20_Shadowlurker/image2.jpg",
    "revision": "5ac54287ee5f4229f511494c8ff36e93"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-20_Shadowlurker/image3.jpg",
    "revision": "00b32d6566c2fad7dc07294cdc02230f"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-20_Shadowlurker/image4.jpg",
    "revision": "064e7701fabeedac72b6192091601a24"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-21_Prisonhood/image1.jpg",
    "revision": "ed7edfa7336e49b1ea7292a0d3e91697"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-21_Prisonhood/image2.jpg",
    "revision": "8d6e7f18aa0128a12623145b1f54dc54"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-21_Prisonhood/image3.jpg",
    "revision": "a23e0efba39d8a5f5540d8fb0eb5da7b"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-21_Prisonhood/image4.jpg",
    "revision": "9fc8fda1cf4b455b83287a71a65dce14"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-21_Prisonhood/image5.jpg",
    "revision": "5822849d86c3e6af1c6b25e109ecf53e"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-21_Prisonhood/image6.jpg",
    "revision": "b13fd0313185fa3cad01a269ea06fbf6"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-21_Prisonhood/image7.png",
    "revision": "505681b94d20d38734cdb53770be5fe9"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-22_YukiVsPanda/image1.jpg",
    "revision": "c24400d9aa82c02094384873e6efee8b"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-22_YukiVsPanda/image2.jpg",
    "revision": "07f26519bb81bde15c8ca54a030cb77f"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-22_YukiVsPanda/image3.jpg",
    "revision": "e6433878b8f7b1a94a3315bb5dfe6fff"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-22_YukiVsPanda/image4.jpg",
    "revision": "21d73f39d66a4df4c7e34804987cae2e"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-22_YukiVsPanda/image5.jpg",
    "revision": "bb37ac6d808f2ec37a2d7dee37478c0e"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-22_YukiVsPanda/image6.jpg",
    "revision": "513ec0cccbbc4d3e7c7300791b1beb21"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-22_YukiVsPanda/image7.jpg",
    "revision": "98d31c43e0adb9ae03c3308b5e3ca444"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-24_ThisIsNormal/image1.jpg",
    "revision": "d31e1c075f0f05e5c23dcb0b9a8d9d62"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-24_ThisIsNormal/image2.jpg",
    "revision": "507c2c06bfefb7a3684e28d579663625"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-26_Caravaneer2/image1.jpg",
    "revision": "bd72a27ee9638d04ef5c3acd361bb0e1"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-26_Caravaneer2/image2.jpg",
    "revision": "f0dc1c99b95da3defedd96a14ccc6025"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-26_Caravaneer2/image3.jpg",
    "revision": "6b24f06c18869e2c8dbb075e9a667a85"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-26_Caravaneer2/image4.jpg",
    "revision": "8575a22044df8f31f9cee862838db9cf"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-26_Caravaneer2/image5.jpg",
    "revision": "7638f5ab7c7d5b5a278c0c269bdae422"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-03-26_Caravaneer2/image6.jpg",
    "revision": "6b2a27fd3d61804010db39e8a51cd5cf"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-01_ArmyMen3/image1.jpg",
    "revision": "173dfdb7293f01e6e60fa58ce33ae62f"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-01_ArmyMen3/image2.jpg",
    "revision": "de798c27fe9604941f3cdd24181546bd"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-01_ArmyMen3/image3.jpg",
    "revision": "ec2a7a9a8774cb5b2c01d67b8d4442c5"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-01_ArmyMen3/image4.jpg",
    "revision": "57a5e970597f3ba03e904deb47d6d852"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-01_ArmyMen3/image5.jpg",
    "revision": "689426e2328af6970a456654853c0a6d"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-01_ArmyMen3/image6.jpg",
    "revision": "7f0f406210596cb2e23de523b32b1740"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-01_ArmyMen3/image7.jpg",
    "revision": "4aad1805627179cbcb4552754b90731f"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-01_ArmyMen3/image8.jpg",
    "revision": "173dfdb7293f01e6e60fa58ce33ae62f"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-03_LifeEssence/image1.jpg",
    "revision": "23c560be26525f9dd8feb4038560c46a"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-03_LifeEssence/image2.jpg",
    "revision": "9e4e319f065b67d62bfd086d2ec701e9"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-03_LifeEssence/image3.jpg",
    "revision": "8a97e4b9f9f46a2374dcc5d9f3aa0f27"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-03_LifeEssence/image4.jpg",
    "revision": "5b0ed78f26309666f2cf5d94aabb5291"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-03_LifeEssence/image5.jpg",
    "revision": "65a85df77a68596ca9f4fa3a1625110d"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-03_LifeEssence/image6.jpg",
    "revision": "72ee0e02d69c613d27c64b4af0303ab5"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-03_LifeEssence/image7.jpg",
    "revision": "f24d7cdb0616627945e07452fd1a56a4"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-05_TowerOfGuns/image1.png",
    "revision": "2fbf9f405d5be8bd99805ade06b7964b"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-05_TowerOfGuns/image10.jpg",
    "revision": "fd0763f6f229687bbc75a61c0f7a5ca7"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-05_TowerOfGuns/image11.jpg",
    "revision": "520d7a254b380ac68d860dfdf672257c"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-05_TowerOfGuns/image2.jpg",
    "revision": "48d7ade2d8f8b150698ff2ed92f1f5eb"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-05_TowerOfGuns/image3.png",
    "revision": "492db2a417835f95b4d3dcb80f8422bc"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-05_TowerOfGuns/image4.png",
    "revision": "d5e7c367b8772f9fd271c14a7b92d2d8"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-05_TowerOfGuns/image5.png",
    "revision": "00df4ab01cda692490fe960e1c62d524"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-05_TowerOfGuns/image6.jpg",
    "revision": "f04f1c20328b95a291bb158b949e752b"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-05_TowerOfGuns/image7.jpg",
    "revision": "56cd148c847e9d1e572ba685c636f80d"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-05_TowerOfGuns/image8.jpg",
    "revision": "32beecbb0188bce1ee1f2ffbdc459918"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-05_TowerOfGuns/image9.jpg",
    "revision": "48ca4959a17874f31ccdbe2d1c068842"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-11_PlanetExplorers/image1.jpg",
    "revision": "a7bd23e54c13cfedfc74f019153fa350"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-11_PlanetExplorers/image10.jpg",
    "revision": "7eb0de5b6a49230830f8b14d7e49a21a"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-11_PlanetExplorers/image11.jpg",
    "revision": "08d5b6f1be486aeda749b9c787733ec6"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-11_PlanetExplorers/image12.jpg",
    "revision": "4493acf6c791acfc5fd5e6cc0380e914"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-11_PlanetExplorers/image13.jpg",
    "revision": "9f3fd48941f83484b1b3f1d999306cc7"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-11_PlanetExplorers/image2.jpg",
    "revision": "1b53b42d6f6fc430c055d6861fd8383c"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-11_PlanetExplorers/image3.jpg",
    "revision": "1157d7cb31d41809050aa8fc08c69d07"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-11_PlanetExplorers/image4.jpg",
    "revision": "50940dfe47ebd228eca982b9ff59c3a5"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-11_PlanetExplorers/image5.jpg",
    "revision": "a89976b97983f854b9e812d6417147e9"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-11_PlanetExplorers/image6.jpg",
    "revision": "d9ff99e6242ab96f652a7209d8baa07a"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-11_PlanetExplorers/image7.jpg",
    "revision": "947e3a2d6079a41ecf6e359977a1b306"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-11_PlanetExplorers/image8.png",
    "revision": "8c0cce94724fce633adef9881df7b485"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-11_PlanetExplorers/image9.jpg",
    "revision": "5e8693b0d8804fab484ca5bb72ee1ffe"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-13_SangFroid/image1.jpg",
    "revision": "8047492b24054f2f4c1377dd41c9f6ed"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-13_SangFroid/image10.jpg",
    "revision": "bc684c6fc3948df91e45b1f1a6c52618"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-13_SangFroid/image11.jpg",
    "revision": "edc5bc1bf1c5941e7b23bda9cb9b4480"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-13_SangFroid/image12.jpg",
    "revision": "a49b345c9265fbbf21284546af86c055"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-13_SangFroid/image13.jpg",
    "revision": "694cdf48da02964c0687a94fd741a650"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-13_SangFroid/image2.jpg",
    "revision": "599388471d74d344f937ee243855b242"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-13_SangFroid/image3.jpg",
    "revision": "c4394ab19c2d2938d84fc2272a8f0356"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-13_SangFroid/image4.jpg",
    "revision": "286e4dce6f67acfc63d3b28b96481b65"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-13_SangFroid/image5.jpg",
    "revision": "48aec9824256e02c78ef8b5f3aa84ffe"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-13_SangFroid/image6.jpg",
    "revision": "cb0e7aa1dd96cdb6218175db906abbbf"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-13_SangFroid/image7.jpg",
    "revision": "05cffef2939b69fe7bc8fffe24288ecc"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-13_SangFroid/image8.jpg",
    "revision": "ab45b2524d98451f99aefb1b5a1da118"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-13_SangFroid/image9.jpg",
    "revision": "14af306a60783767a1af5f5f8c67d74c"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-15_Titanic/image1.jpg",
    "revision": "b8dfb9102ccf2cc92fc34aa280f08cc9"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-15_Titanic/image10.jpg",
    "revision": "66682a6bfce09cfd180a83af40d9f3a6"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-15_Titanic/image11.jpg",
    "revision": "3b74fd37a7d9e4e65b3eeeae85033656"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-15_Titanic/image12.jpg",
    "revision": "79421de15b792aa4ccbd5e367da3ba4f"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-15_Titanic/image2.jpg",
    "revision": "45afc084a6c9e5bfc7e02840ef38024c"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-15_Titanic/image3.jpg",
    "revision": "8a7a047fd8542b0d68604b43a8b74202"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-15_Titanic/image4.jpg",
    "revision": "7282bbef120a5418fd36b6568e84e61d"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-15_Titanic/image5.jpg",
    "revision": "3d1fad1043444f389b6367e33f32105b"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-15_Titanic/image6.jpg",
    "revision": "45f6f65bc0f09d231beef2a342529728"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-15_Titanic/image7.jpg",
    "revision": "6663c04488bc344d01be9aa4cd1d3cf9"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-15_Titanic/image8.jpg",
    "revision": "bfe4f8fe33a5eca2d5b35745f9630faa"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-15_Titanic/image9.jpg",
    "revision": "bb17bcb13fa1865d7c73498632a033f2"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-16_Runes/image1.jpg",
    "revision": "0f46f35ad92b1477a363dc757e472b20"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-16_Runes/image2.jpg",
    "revision": "38c9ca222aab8cc44984ca4083a4942c"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-16_Runes/image3.jpg",
    "revision": "20a6885c9142134aae37df4d06d52571"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-16_Runes/image4.jpg",
    "revision": "e90e4f2d3db64d1bfe7666037b58d58f"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-16_Runes/image5.jpg",
    "revision": "1358d3899a04b5ddf45fb2e68a62fffd"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-16_Runes/image6.jpg",
    "revision": "0305a218bc5817fc084149b815850c06"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-16_Runes/image7.jpg",
    "revision": "140738b1f29726a381773bea82783cde"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-17_LeviathanCrossfire/image1.png",
    "revision": "bdb0db3c8620478df4f1e1791b0f7c52"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-17_LeviathanCrossfire/image2.jpg",
    "revision": "689dfbc01761c5548bb13344e664096a"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-17_LeviathanCrossfire/image3.jpg",
    "revision": "82a01cacd45c6dad1a58630a4fed5f35"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-17_LeviathanCrossfire/image4.jpg",
    "revision": "066c5b01983cee0fd12af57224ec91cf"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-17_LeviathanCrossfire/image5.png",
    "revision": "1cbb8519b460b98ec9b534ba705899d9"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-17_LeviathanCrossfire/image6.png",
    "revision": "e6aad3dd2452c8db0ac3913077ef15bb"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-17_LeviathanCrossfire/image7.png",
    "revision": "2cf22786b597039bd4dd033709ceb97b"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-17_OneLifeLeft/image1.jpg",
    "revision": "db4f17d2c77770830065ff86dcf39798"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-19_DreadOut/image1.jpg",
    "revision": "91ab146483da921afadde595ad300c1d"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-19_DreadOut/image2.png",
    "revision": "5285ba17551853f34669d5f3cd5434e7"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-19_DreadOut/image3.jpg",
    "revision": "5e2a63899fc1f942a97c37374de85236"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-19_DreadOut/image4.png",
    "revision": "901bd62bc86fea78989629ec8e500058"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-19_DreadOut/image5.jpg",
    "revision": "ed06eb504a713536e9d05181bd25eb36"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-19_DreadOut/image6.jpg",
    "revision": "82797c9e1bdaac040557385d63a8efcf"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-19_DreadOut/image7.jpg",
    "revision": "73e87e33214bae5415b535c61b047159"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-19_DreadOut/image8.jpg",
    "revision": "ed4c5a27fe4e590f4754669521e3bec0"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-19_DreadOut/image9.jpg",
    "revision": "1446e055a564775bbf85135412e05ac9"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-21_SonOfNor/image1.jpg",
    "revision": "6db612ad1adc86394145d2dbf008ae78"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-21_SonOfNor/image2.jpg",
    "revision": "7eb0f705595ae29fdf3740209e22bac8"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-21_SonOfNor/image3.jpg",
    "revision": "503976a147e77e51ef996a63afda208f"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-21_SonOfNor/image4.jpg",
    "revision": "6e29916ea8a34453700f352d7dc6ad19"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-21_SonOfNor/image5.jpg",
    "revision": "0e2b7a92664c5b7f61daacb6c0f97ffe"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-21_SonOfNor/image6.jpg",
    "revision": "df0c407ea360c3333b2d2d317bacb5f3"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-21_SonOfNor/image7.jpg",
    "revision": "b18927a283786b19cf5e8ff8dbae68ad"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-21_SonOfNor/image8.png",
    "revision": "564d1334c46d244c22d35dbcd5393b4e"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-23_Oceania/image1.jpg",
    "revision": "5029917134900956505fc07f969cbf7c"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-23_Oceania/image2.jpg",
    "revision": "9c0709172457638827efab9cfbb2cb2e"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-23_Oceania/image3.jpg",
    "revision": "72d4c6e6782b89dc6b1d22d05a046753"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-23_Oceania/image4.jpg",
    "revision": "78f059113d5e0f0f7f81f41034d3f558"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-23_Oceania/image5.jpg",
    "revision": "0db43db70d44eaa467c1dca37cba71cf"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-23_Oceania/image6.jpg",
    "revision": "a91f1d3b2b4a64657d596fb384520e35"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-23_Oceania/image7.jpg",
    "revision": "a50d72749eab11a5c55d2068bb4cb319"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-23_Oceania/image8.jpg",
    "revision": "c9fb70ec4dc20201f0a783c4169dd5c2"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-24_BlackSoul/image1.jpg",
    "revision": "f1e2ffd6f28ad03975bddfa34b8ed82d"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-24_BlackSoul/image2.jpg",
    "revision": "a6726b9e94b791ac903081407723c4c6"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-24_BlackSoul/image3.jpg",
    "revision": "81a179e3f0d788928e85a471f4310887"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-24_BlackSoul/image4.jpg",
    "revision": "ceb65b0f1a2a52c24122cffbc230f854"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-24_BlackSoul/image5.jpg",
    "revision": "fc4e23b17fa1b9413941bd7330afbfec"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-24_BlackSoul/image6.jpg",
    "revision": "12b2d1f4c84c3c67a0686cc064019d8e"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-24_BlackSoul/image7.jpg",
    "revision": "7fa9482353d9b047c8442ba3183fc73d"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-24_BlackSoul/image8.jpg",
    "revision": "159094bec3a88654026cb01fa4102cea"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-24_BlackSoul/image9.jpg",
    "revision": "edef323af40be3c9f28bce825f54bf9a"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-25_KingsportCases/image1.png",
    "revision": "b2ef9d4a9f2e1999d3aaa05011d9ee06"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-25_KingsportCases/image2.png",
    "revision": "e7efa0067442d7e87295674435df787a"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-25_KingsportCases/image3.png",
    "revision": "d4786bf9d21d00ef9f44a4f46f5baf62"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-25_KingsportCases/image4.jpg",
    "revision": "bd4093288975c01af4bf30190d367176"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-25_KingsportCases/image5.png",
    "revision": "6702d7487576fd015572cc5150ea3362"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-25_KingsportCases/image6.png",
    "revision": "742bd34a6a8dc6399173d08beeb7ee94"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-25_KingsportCases/image7.png",
    "revision": "98065b05c544e132a2ba7bfd598e30e2"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-25_KingsportCases/image8.png",
    "revision": "102cd35ae2db4ea282115004085690c3"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-25_KingsportCases/image9.png",
    "revision": "a9f964a0d804b8193b5be0d5dce0c0f5"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-30_GloriaVictis/image1.jpg",
    "revision": "dce00c583231a8ca92dfe4fb4075a0a4"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-30_GloriaVictis/image10.png",
    "revision": "8f1624797c8e49518059fb70341cb4c7"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-30_GloriaVictis/image11.jpg",
    "revision": "99f9f3777965f0c782ff2608993c688a"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-30_GloriaVictis/image2.jpg",
    "revision": "919d2fc9606b90f6dca7e62fdf926faf"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-30_GloriaVictis/image3.jpg",
    "revision": "b145a9249334c7969123efef8adc5468"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-30_GloriaVictis/image4.png",
    "revision": "c5da356d707423bb9d15989dad326875"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-30_GloriaVictis/image5.jpg",
    "revision": "b65917cd35f7c482a28bc78bcaab92fe"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-30_GloriaVictis/image6.jpg",
    "revision": "074b1c382fe8ddf3641a60d0a08b7bf5"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-30_GloriaVictis/image7.png",
    "revision": "e8dc2ca0ae4f4af0253b194625453534"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-30_GloriaVictis/image8.png",
    "revision": "467b3e86843414afdf38ac8d4c88856f"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-04-30_GloriaVictis/image9.jpg",
    "revision": "f60375cf0c4431a8ba797dbf56d64f2b"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-03_Aurora/image1.png",
    "revision": "a2797b97b88edfea12649fdf05fd88de"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-03_Aurora/image2.png",
    "revision": "fa0e34f24a10af6f84acd620a329ce53"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-03_Aurora/image3.png",
    "revision": "44d55d9588f4e57f7595a43edf4b0a56"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-03_Aurora/image4.jpg",
    "revision": "4ab8bf3ce79f08d09d39278ec286ee91"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-03_Aurora/image5.png",
    "revision": "46a3e77429a914a0fc7ca1b620ead51a"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-06_RunningDude/image1.jpg",
    "revision": "2a5c8c9be4df50e1d8ca17530c4263ae"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-06_RunningDude/image2.jpg",
    "revision": "5a1fc1955d337c45fa715f881983b777"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-06_RunningDude/image3.jpg",
    "revision": "3fa0199e3b86e6d04ea6aa4deb23ba10"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-06_RunningDude/image4.jpg",
    "revision": "db3f1cdda23155567c46ac258f574e5b"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-06_RunningDude/image5.jpg",
    "revision": "944b63b9053880378b161021063d2953"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-06_RunningDude/image6.jpg",
    "revision": "3a7abc7411fc69029e9c498dc0923650"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-06_RunningDude/image7.jpg",
    "revision": "34873386d56efa6143194a8cbe6e1a13"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-07_Wave/image1.jpg",
    "revision": "0df19ec53a5438e7852570241ad6cb8a"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-07_Wave/image2.jpg",
    "revision": "82eae902b1a14ab0191768b1b3d622d0"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-07_Wave/image3.jpg",
    "revision": "6af31d464429ed9a8a7c1d595d4863ea"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-07_Wave/image4.jpg",
    "revision": "4a6dce15c5a5d4fe8bec5b5baed2daaf"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-07_Wave/image5.jpg",
    "revision": "26ff6de3a9e80f30cd8507b0ad5ebe89"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-07_Wave/image6.jpg",
    "revision": "e30be39f6820e3617fde3407072b6e8f"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-07_Wave/image7.jpg",
    "revision": "2ca0ff627fd58ffd65792c4a4650b478"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-07_Wave/image8.jpg",
    "revision": "5c37f7bb28f1c898cd0a796460290dc4"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-11_BeyondInfinity/image1.jpg",
    "revision": "ca3918b596d69345902b93cab250995a"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-12_Outpost/image1.jpg",
    "revision": "969ae9c2a8b0695d291d08f5d510520b"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-12_Outpost/image2.png",
    "revision": "9f2afa3957285da421fe2ec81d4b4fd3"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-12_Outpost/image3.png",
    "revision": "f65650157c2a7ebc4940d45109db55aa"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-12_Outpost/image4.png",
    "revision": "ea7060524456b08d1660690443f91c42"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-12_Outpost/image5.png",
    "revision": "be4ed8539d5b403baff250d5264410a8"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-12_Outpost/image6.png",
    "revision": "19dd1ba71a924337f8b1c0b20bba55c0"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-12_Outpost/image7.png",
    "revision": "70950ce872bd828046613e6a146a8449"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-12_Outpost/image8.png",
    "revision": "79c4094b3b3369394c375e7daecab4af"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-12_Outpost/image9.png",
    "revision": "d86046a881e897727e4ba5e46ccfc6ec"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-13_CubeMetalHeart2/image1.jpg",
    "revision": "d2a3634a6b26e4107fb009365bcc0585"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-19_Warlords/image1.jpg",
    "revision": "6985c503e2440e09b0f98097ebc973d7"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-19_Warlords/image2.jpg",
    "revision": "e1733add2770d1800357a3e1c50f5bdb"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-19_Warlords/image3.jpg",
    "revision": "772f0dcd2d43cdaa22926db4c104faa6"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-19_Warlords/image4.jpg",
    "revision": "2736a2f63cecc8247ac82740b88711e4"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-19_Warlords/image5.jpg",
    "revision": "b609c9767485b3ce1752a3ac5e34f189"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-19_Warlords/image6.jpg",
    "revision": "86479a854fdfb90037ef509a73e91c3b"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-19_Warlords/image7.jpg",
    "revision": "14e0c76554569c97263986cc63fff87c"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-19_Warlords/image8.jpg",
    "revision": "aad8e8b41f96e70d2e95db02146461f3"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-19_Warlords/image9.jpg",
    "revision": "0b28ba8fb5335a25082b0327a7f1ed8b"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-21_MemoryOfSoul/image1.png",
    "revision": "28e06c30374b410246bc759213b94431"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-21_MemoryOfSoul/image10.jpg",
    "revision": "7928cc5248fca24edb621243339239a8"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-21_MemoryOfSoul/image2.jpg",
    "revision": "90865b965988fcf9cd7118cc95a7122b"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-21_MemoryOfSoul/image3.jpg",
    "revision": "9c4620e4447474c3327e3695e4658d0a"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-21_MemoryOfSoul/image4.jpg",
    "revision": "00323e2dfaa5a9b9feb32349776439f2"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-21_MemoryOfSoul/image5.jpg",
    "revision": "e581a66f0794b01bd6fe8b02a2d17bb8"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-21_MemoryOfSoul/image6.jpg",
    "revision": "926a0a8692502227402c7e88c3462ce7"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-21_MemoryOfSoul/image7.jpg",
    "revision": "4f40bf239470d9d6d6471f4ae5853f9c"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-21_MemoryOfSoul/image8.jpg",
    "revision": "445969f3dea1a1a37bdca7fb61f8be9a"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-21_MemoryOfSoul/image9.jpg",
    "revision": "b646c0c7e12663a0bc0943190871e46c"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-23_JaggedAllianceFlashback/image1.jpg",
    "revision": "b244d8c43d3e4f0c0554d2c41f0c8748"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-23_JaggedAllianceFlashback/image10.jpg",
    "revision": "5b019d58c48bedaa3b2db649bee9f0ab"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-23_JaggedAllianceFlashback/image11.jpg",
    "revision": "f44519812b8832db10b0e66b602f238c"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-23_JaggedAllianceFlashback/image2.jpg",
    "revision": "889e530b818f9724bd460ab9297c79cd"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-23_JaggedAllianceFlashback/image3.jpg",
    "revision": "c2f2eec3a1e2754ecb94904a6eb97f1a"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-23_JaggedAllianceFlashback/image4.jpg",
    "revision": "5ff7570dba36e15c3d16effc44708a50"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-23_JaggedAllianceFlashback/image5.jpg",
    "revision": "96cc9857fe52e1aaaea6016c4653bbc5"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-23_JaggedAllianceFlashback/image6.jpg",
    "revision": "ffb4ed920f9da2bd0e2e4b0e279abc07"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-23_JaggedAllianceFlashback/image7.jpg",
    "revision": "18661eb309bfe8202b1164b6dd14824b"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-23_JaggedAllianceFlashback/image8.jpg",
    "revision": "2dcf0dbe71bc63ca37f71727c91d74fc"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-23_JaggedAllianceFlashback/image9.jpg",
    "revision": "c120e37e3bfde902b212501d08e3fac8"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-28_TheRealm/image1.jpg",
    "revision": "7280a7b2247ee3653cb17564dee93fd1"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-28_TheRealm/image10.jpg",
    "revision": "17458c1da295eba4f733b5353190a1d0"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-28_TheRealm/image2.jpg",
    "revision": "36bf376552b667976c8daf04f648f469"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-28_TheRealm/image3.jpg",
    "revision": "f5cb9302f99c336f51e4df6c5a78a5e4"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-28_TheRealm/image4.jpg",
    "revision": "2e39a520bc245942c8c72a272fd5b3a5"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-28_TheRealm/image5.jpg",
    "revision": "c67b46f501df14a52f1e984b7cccfb3e"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-28_TheRealm/image6.jpg",
    "revision": "a01171fa9bdae2b3589d8057f180626e"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-28_TheRealm/image7.jpg",
    "revision": "c5fa71094a08129e86a9126e7a4ebe44"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-28_TheRealm/image8.jpg",
    "revision": "3a84d080ca340dd547acfbd9d8a9cdb3"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-05-28_TheRealm/image9.jpg",
    "revision": "d220becf4f5178a4a1684c54d655b113"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-06-03_Doorways/image1.png",
    "revision": "35666a582d971835eb6dab5f49e57708"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-06-03_Doorways/image10.jpg",
    "revision": "7ec66f5d5a7fead07b3251345d38a359"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-06-03_Doorways/image2.jpg",
    "revision": "7e8440ed2955c1d60157648a0da173ea"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-06-03_Doorways/image3.jpg",
    "revision": "99d5c5f459682ef62c7a3cc98b74ccd4"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-06-03_Doorways/image4.jpg",
    "revision": "9469109fae2e8f09471d9ac486069220"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-06-03_Doorways/image5.jpg",
    "revision": "d3795070e6514f326994c3c1590b547b"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-06-03_Doorways/image6.jpg",
    "revision": "dfd0d6443bc6eec14c64fead9492d192"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-06-03_Doorways/image7.jpg",
    "revision": "84022322b84870d6590df5c0151caeeb"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-06-03_Doorways/image8.jpg",
    "revision": "6731fd43898ed1f3ee3ed471edd47ada"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-06-03_Doorways/image9.jpg",
    "revision": "1af3277705effeaef5cd27b5d3446a9a"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-06-18_ShroudsBurden/image1.png",
    "revision": "80abefadcf91449132b9678c78b430a9"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-06-18_ShroudsBurden/image2.png",
    "revision": "c5e0a5962685800b401d0a1913eb3ba6"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-13_QuickSlickDeadlyTrailer/image1.jpg",
    "revision": "4b3f12019ae90e99c477c632fcbb7d40"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-15_JackieRose/image1.jpg",
    "revision": "e252c9bc34b65fc4fbfa68e91c059f3a"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-15_JackieRose/image2.jpg",
    "revision": "8328e27fdeddb789cccce3622f19709e"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-15_JackieRose/image3.jpg",
    "revision": "f1035b84d2568c075c9c6e0f8b34197f"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-15_JackieRose/image4.jpg",
    "revision": "83b7d2e6f0a56bddacc0fe6f031f4c10"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-15_JackieRose/image5.jpg",
    "revision": "8b70862e000b889d3c05935b9c3d7784"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-15_JackieRose/image6.jpg",
    "revision": "e8f0ab72d0ffbf3e8ae4626595794030"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-15_JackieRose/image7.jpg",
    "revision": "fb756fe1d10704f8d4f700e963338d70"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-16_MotteIsland/image1.jpg",
    "revision": "ea87444e9c4640bd862d6098b4bb6f1e"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-17_LucunaPassage/image1.png",
    "revision": "34f3bdd237e7b7196e0507be3745efca"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-17_LucunaPassage/image10.png",
    "revision": "e371c2a35cb13276c45ab67244706e28"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-17_LucunaPassage/image2.png",
    "revision": "75f33390f8a561aa82f06a9257ac0245"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-17_LucunaPassage/image3.png",
    "revision": "534b10322cf0ef6a3562f697668278d0"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-17_LucunaPassage/image4.png",
    "revision": "03c93a901f2ef292a342330e7729d422"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-17_LucunaPassage/image5.png",
    "revision": "c4342af6ab7c7ea6698026061f005377"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-17_LucunaPassage/image6.png",
    "revision": "b326191989250f6524e08a5b819c8e32"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-17_LucunaPassage/image7.png",
    "revision": "8ea1535d1d981c2222327d76d2aa637f"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-17_LucunaPassage/image8.png",
    "revision": "4e6615d28d22a83ef0c99fa8e3aee624"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-17_LucunaPassage/image9.png",
    "revision": "4cd779c5b8aaaa88ca5dccf6e31719b3"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-19_ProjectTemporality/image1.jpg",
    "revision": "12c7f75562a71494cb236b1cd6413ec0"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-21_DeadPlasma/image1.png",
    "revision": "20d8fc45e13befe6968dfb5db8491e51"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-21_DeadPlasma/image10.jpg",
    "revision": "e7b14995674d200c7b89b1f7a4bceceb"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-21_DeadPlasma/image2.png",
    "revision": "8fcff4dabfae8b1d42bc0b4c23e697d4"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-21_DeadPlasma/image3.png",
    "revision": "dcb482c84bef290ad021b2d9d220c8b7"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-21_DeadPlasma/image4.jpg",
    "revision": "0a54796fd651389edeb8e4c672c78c81"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-21_DeadPlasma/image5.jpg",
    "revision": "0fc8ef2ef8523da1697ec5ce1f8acaf7"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-21_DeadPlasma/image6.jpg",
    "revision": "74abb9383c4545188c93f3f7001a70ce"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-21_DeadPlasma/image7.jpg",
    "revision": "c288350a97fb3607198635248efbb0bb"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-21_DeadPlasma/image8.jpg",
    "revision": "81607e4f5d75bee81bc49b610fd0bfa5"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-21_DeadPlasma/image9.jpg",
    "revision": "4732c349b66c503ad05f6f5072476476"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-27_QuickSlickDeadly/image1.jpg",
    "revision": "ed7709fa547382018e3e5389aa9d5a74"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-27_QuickSlickDeadly/image2.jpg",
    "revision": "9937d5c6320d0eb3ccdbb561afe2fd1e"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-27_QuickSlickDeadly/image3.jpg",
    "revision": "bcdf78d9ba26d4dcba29db1925968cbf"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-27_QuickSlickDeadly/image4.jpg",
    "revision": "b6b8f79891f5b28968e4f6d5389e1403"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-27_QuickSlickDeadly/image5.jpg",
    "revision": "e9ca97ff5620d39822dc5e1fd5cf1099"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-27_QuickSlickDeadly/image6.jpg",
    "revision": "1adc22403d4ceba05d90dfa8a4a30cf7"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-27_QuickSlickDeadly/image7.jpg",
    "revision": "4479fd4343f7df4b26642534ab9247fc"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-27_QuickSlickDeadly/image8.jpg",
    "revision": "a554a695aa14e80a41ac140c276a2f15"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-27_QuickSlickDeadly/image9.jpg",
    "revision": "a70613da9a23cbd60ed43da23afcef46"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-27_SNOW/image1.png",
    "revision": "8335e880a0e50433ba57832d55f98d04"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-27_SNOW/image10.jpg",
    "revision": "665453487cee76046c6996900df65742"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-27_SNOW/image11.jpg",
    "revision": "c1bf4e21062b27021b577b0054d3ee05"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-27_SNOW/image12.jpg",
    "revision": "797269adaab601a10de5968c75740c9b"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-27_SNOW/image13.jpg",
    "revision": "998fb25c60ecdaaded79ad5f325c42dd"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-27_SNOW/image2.jpg",
    "revision": "4a707552ed7bbfbb0f2f3f5009ad2d99"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-27_SNOW/image3.jpg",
    "revision": "7888eec1ecea13b48444679726b8a83a"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-27_SNOW/image4.jpg",
    "revision": "5a8e3601a1e5ac5c6684cce3844162c4"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-27_SNOW/image5.jpg",
    "revision": "cd21b9c429cc4d2ec6cb9c3e8177d007"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-27_SNOW/image6.jpg",
    "revision": "162119a60951b91e3d19f71bd440fb6a"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-27_SNOW/image7.jpg",
    "revision": "9161f5a156e29f544226ef2e5a7139a3"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-27_SNOW/image8.jpg",
    "revision": "ad5d7a8504a225e7f40a5f4678ed571b"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-27_SNOW/image9.jpg",
    "revision": "15225de368c024c0cfac87e33ced5a8a"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-29_AdventureTidesOnline/image1.png",
    "revision": "299b713c8ba7fb34ce4812919fe9e03e"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-29_AdventureTidesOnline/image2.png",
    "revision": "f2c2bdb3ec5820be66f8f520ad7997d9"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-29_AdventureTidesOnline/image3.png",
    "revision": "d5731ce115c6af073ab9c1806692b2e8"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-29_AdventureTidesOnline/image4.png",
    "revision": "7d120ba85b19cc45b89ef3dc0c6b9cc1"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-07-29_AdventureTidesOnline/image5.png",
    "revision": "fd915f1b3284ca6a98fc994be84ba9c0"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-13_SociallyAwkward/image1.png",
    "revision": "2ff7e5641d3983a2b26121879f0c6768"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-13_SociallyAwkward/image2.png",
    "revision": "1ec667d777e79f978ff4aeefdce1081f"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-13_SociallyAwkward/image3.png",
    "revision": "871733da343647401017c914a8830453"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-13_SociallyAwkward/image4.png",
    "revision": "c1405f9b5baa3062660248395ac0157e"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-13_SociallyAwkward/image5.png",
    "revision": "5a93be18f700f9425de0d030c889493a"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-13_SociallyAwkward/image6.jpg",
    "revision": "95072f7182de90d0c9134d006d5003a6"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-13_SociallyAwkward/image7.png",
    "revision": "2835cfe51ef48668d6402252c7aa1f5a"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-13_SociallyAwkward/image8.png",
    "revision": "04588d04a275594757bbea6e514ca089"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-18_FluoroVu/image1.png",
    "revision": "50f88e9f70978d94c7d8ae35704f0b11"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-18_FluoroVu/image10.png",
    "revision": "b8d00155a9c0ecafa6f57d55a300f50e"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-18_FluoroVu/image2.png",
    "revision": "cb4c57e8da565d757fe9a7dec471c5f4"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-18_FluoroVu/image3.jpg",
    "revision": "083d5e6f02393306af76686b4083aae8"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-18_FluoroVu/image4.png",
    "revision": "2cd4e79358a6029a2c06e3e9691c6f0d"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-18_FluoroVu/image5.png",
    "revision": "f361958232fceb901732a063136d4398"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-18_FluoroVu/image6.png",
    "revision": "30125f459d3d8fa68e86e6e06543a55f"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-18_FluoroVu/image7.png",
    "revision": "762dd5f98d498b4d606184077cd778e8"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-18_FluoroVu/image8.png",
    "revision": "af8a33c09e2cdfce09db891b4554fa61"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-18_FluoroVu/image9.png",
    "revision": "02ce56af8a12814e4995452bff2e44e6"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-18_SaltBurn/image1.jpg",
    "revision": "c7685c02f00b2f0a6415220868bd8530"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-18_SaltBurn/image10.jpg",
    "revision": "724d63b5cd9cc42440d81935291b5887"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-18_SaltBurn/image2.jpg",
    "revision": "a1dff16d384d349f30d368e39201ace3"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-18_SaltBurn/image3.jpg",
    "revision": "a35ab9b8de060858d21a9ec2fb98f5ce"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-18_SaltBurn/image4.jpg",
    "revision": "f5369f0338f87703fa5d8068c9c05a81"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-18_SaltBurn/image5.jpg",
    "revision": "cb76e4c7f76050908df369cb5313a3eb"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-18_SaltBurn/image6.jpg",
    "revision": "aa71c08a590f3f8aee35f6a3de184eff"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-18_SaltBurn/image7.jpg",
    "revision": "14b707bb05353d60ba9109573b2c5be8"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-18_SaltBurn/image8.jpg",
    "revision": "2473ab776cd3c5ac0a4f3848be7b8ae3"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-18_SaltBurn/image9.jpg",
    "revision": "7a277c4dd822b0e0cd41391d11111a00"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-19_StoneRage/image1.jpg",
    "revision": "d999dea8111b13b545f4ae9bed04e4a1"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-19_StoneRage/image2.jpg",
    "revision": "841e52644790d60dcce83a57ddabd140"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-19_StoneRage/image3.jpg",
    "revision": "0d6907f6d45ad4c1e7db3db10cabea9b"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-19_StoneRage/image4.jpg",
    "revision": "6a6b872364e79cc1088115e4f2ffaa54"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-19_StoneRage/image5.jpg",
    "revision": "47fc58cb67ac5b4d5116d1b62c42f8fb"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-19_StoneRage/image6.jpg",
    "revision": "8c18b20f4d0b9a466180b9d3a08653fc"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-19_StoneRage/image7.jpg",
    "revision": "fb364eac0951773cb330ceb6aba2823e"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-19_StoneRage/image8.jpg",
    "revision": "4f2526c4ccdec17b17ed2c1baa9e3791"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-22_AfterReset/image1.png",
    "revision": "9da1691851b60a29b30b3838804f2d70"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-22_AfterReset/image10.png",
    "revision": "04cef2521e8e6655cc015ac1bba05a5d"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-22_AfterReset/image11.png",
    "revision": "c5f8b36eacb835da5c9a6f26d358e44e"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-22_AfterReset/image12.png",
    "revision": "dc7b79abadc0e4f7f694063e49e23d89"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-22_AfterReset/image2.png",
    "revision": "dd48df93bed859be4e6284874e715389"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-22_AfterReset/image3.png",
    "revision": "62916c4ba515347d4ce6895469a09933"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-22_AfterReset/image4.png",
    "revision": "7a7d4f69271672f3ae22ec5b753d2d57"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-22_AfterReset/image5.png",
    "revision": "afb3771d0929c0d107d8f3a9eb5d0913"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-22_AfterReset/image6.png",
    "revision": "d4dd9dd1232d59b4849be170639dfa8f"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-22_AfterReset/image7.png",
    "revision": "456a7a47aec2cded7499f725bd901b63"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-22_AfterReset/image8.png",
    "revision": "3a3a84f2d957586e149e3cb36d34d227"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-22_AfterReset/image9.png",
    "revision": "32e5f0d564ff45e1dd8cb00b3e8fcad3"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-23_RickFuture/image1.png",
    "revision": "0390bdc1bfa8421099680021226d153f"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-23_RickFuture/image2.jpg",
    "revision": "b577a76021fa1f7174a3aef31fb51d56"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-23_RickFuture/image3.jpg",
    "revision": "78cb82e3e019e192a1d78d07bd631d2f"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-23_RickFuture/image4.jpg",
    "revision": "fbd7bcd77823647f40bebd5896a71771"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-23_RickFuture/image5.jpg",
    "revision": "a9753e3654ad97ec7bc8c26ede89250d"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-23_RickFuture/image6.jpg",
    "revision": "74037b92dbb71626ed02bf85210ea4ff"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-23_RickFuture/image7.png",
    "revision": "c1edf94b993167cc6e04a09de778675c"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-25_Bound/image1.webp",
    "revision": "05d285e3f80d258cbd2fbcfc247af4a3"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-25_Bound/image10.jpg",
    "revision": "bc1414519e5c1273dcd9468449b55a20"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-25_Bound/image2.jpg",
    "revision": "7f329ef9c00eeb0143cdbe3797d2bc2e"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-25_Bound/image3.jpg",
    "revision": "a484a9430d3726b74c6f2f56d0b6d6fd"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-25_Bound/image4.jpg",
    "revision": "c4b9e761ebd778c1e1a6d16c52c68cd9"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-25_Bound/image5.jpg",
    "revision": "a731b9997646af477545434fc3ef98e7"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-25_Bound/image6.jpg",
    "revision": "2cf253207ba1d7d11fae57b3210018b6"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-25_Bound/image7.jpg",
    "revision": "4211cedbdbf72b5986a665ad19da68d5"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-25_Bound/image8.jpg",
    "revision": "b2bbc644824210016a36e173615ddfec"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-08-25_Bound/image9.jpg",
    "revision": "3babeb8ce62bf3a0adffb456f0d6d3c6"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-11-03_Playsets/image1.webp",
    "revision": "3a24925a2b3f0cb5c19d8b59b86e7be8"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-11-03_Playsets/image2.gif",
    "revision": "27cef56926535e48b93b0a5ed02e9adb"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-11-03_Playsets/image3.jpg",
    "revision": "5cdf6d0112ba9f6c99a8b2748f0dc402"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-11-03_Playsets/image4.gif",
    "revision": "7140f81fd28621dc0f13c2718fc3aba0"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-11-03_Playsets/image5.gif",
    "revision": "5e5a679faa69d0a49b8de0570d6720f0"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-11-03_Playsets/image6.gif",
    "revision": "b3ab0571a09114426ea68cd8dfc143b6"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-11-03_Playsets/image7.gif",
    "revision": "bfe28d73c56a0fcec4bfb460b5baf220"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-11-03_Playsets/image8.jpg",
    "revision": "ba64b482c7988d0adbcd01c72feeb5ac"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-11-05_PlaysetsTrailer/image1.jpg",
    "revision": "9432cc5b42136150924aba36f20d4835"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-11-05_ShutteredCity/image1.jpg",
    "revision": "fc490a69e70a434f0585ea2d68b7332f"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-11-05_ShutteredCity/image2.jpg",
    "revision": "95f4b2826fd04024a2d865845278022a"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-11-05_ShutteredCity/image3.jpg",
    "revision": "551c7a18e6312c61f77c3bf1671ea762"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-11-05_ShutteredCity/image4.jpg",
    "revision": "32716c1bd0593b7f3431c5fdb9caf974"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-11-05_ShutteredCity/image5.jpg",
    "revision": "f81d478345f158f3c1a3464352f03982"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-11-05_ShutteredCity/image6.jpg",
    "revision": "35a6741230000357728e9a8e195cf2a9"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-11-05_ShutteredCity/image7.jpg",
    "revision": "7bf846f610368e235844a37847dfec56"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-11-08_ChampionOfDema/image1.webp",
    "revision": "7934a466ae8f3a0b553c6b121468d405"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-11-08_ChampionOfDema/image2.png",
    "revision": "fcc6cc0fb1d798f572895a5e39b83d0b"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-11-08_ChampionOfDema/image3.png",
    "revision": "af9f4dabbd9d85fefd7310c52f9fa8c6"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-11-08_ChampionOfDema/image4.png",
    "revision": "bc3207531d8a2e1d80085002482fc42f"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-11-08_ChampionOfDema/image5.png",
    "revision": "77b347def110cc04bf2eb218ae274c17"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-11-08_ChampionOfDema/image6.png",
    "revision": "255772860e0104a5a72f862d27b44e3e"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-11-08_ChampionOfDema/image7.png",
    "revision": "bdc491e7aedae34ea8f6a652694aa5fa"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-11-08_ChampionOfDema/image8.jpg",
    "revision": "8f26289f86fdf8a7e95f6db6191e3491"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-11-13_LinkedPathways/image1.webp",
    "revision": "553c975c1cd76e7976b7eb1c2c03ad25"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2013-11-13_LinkedPathways/image2.png",
    "revision": "fd4ddda59288f82dff542ef27f0380b1"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2014-01-25_DClic/image1.jpg",
    "revision": "f1ba99bf880385dd4f10d141de869dd5"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2014-01-25_DClic/image10.jpg",
    "revision": "f90a4ad5d2e7f0e583c096dae71de576"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2014-01-25_DClic/image11.jpg",
    "revision": "b41d8dd56d65c1c62c124b64e1ba1241"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2014-01-25_DClic/image12.jpg",
    "revision": "8352dcd7d629aa21e14d28c9a868b728"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2014-01-25_DClic/image2.jpg",
    "revision": "97c9d4535f7957366bfd33c7f8f131f8"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2014-01-25_DClic/image3.jpg",
    "revision": "669012e419e2368c41a8860b28a659cd"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2014-01-25_DClic/image4.jpg",
    "revision": "6040a96345fe01925d4a7f44b14bbe7a"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2014-01-25_DClic/image5.jpg",
    "revision": "ef55e1e26e6605f8ae5e9355df8cda13"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2014-01-25_DClic/image6.jpg",
    "revision": "45a5457c26f4070e27cf2342a223108a"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2014-01-25_DClic/image7.jpg",
    "revision": "a58d36f8413f0460b896edb13e99054c"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2014-01-25_DClic/image8.jpg",
    "revision": "926cc385abed62e976cf8db3136da901"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2014-01-25_DClic/image9.jpg",
    "revision": "bd54a017ab5a1dc886e58618dd9bd0c0"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2014-01-26_WeCare/image1.jpg",
    "revision": "961518648539049372bd2bbf393fb5f1"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2014-02-02_CENTS/image1.jpg",
    "revision": "7ff370d80ef3fc938e983ae0b2ae8832"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2014-02-02_CENTS/image2.jpg",
    "revision": "ac4dc7e596d93d432d8fe75f6226f29d"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2014-02-02_CENTS/image3.jpg",
    "revision": "1100826917a344c0593ae4a0cc78b373"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2014-02-02_CENTS/image4.jpg",
    "revision": "03043600776b8167aaf780a6c3c3af5f"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2014-02-03_HOYO/image1.webp",
    "revision": "03fdfdfc1c641dbf4668db3830bf644d"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2014-02-07_COLORINO/image1.jpg",
    "revision": "d16f3b3ce5de1f8844fbcd3ffce5c452"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2014-02-07_COLORINO/image2.jpg",
    "revision": "f21721a2b0e128c240a8735b0a70419a"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2014-02-07_COLORINO/image3.jpg",
    "revision": "598d3064fc39aa820f3304c1fd4dabfd"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2014-02-07_COLORINO/image4.jpg",
    "revision": "b03f8f0d488b052936634a6b22046be5"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2014-02-07_COLORINO/image5.jpg",
    "revision": "5bc26836df52497bb063ef028144200e"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2014-02-07_COLORINO/image6.jpg",
    "revision": "432451480dc10c73af20235640c3578b"
  },
  {
    "url": "../../src/articleArchive/authorAlexanderSullivan/2014-02-07_COLORINO/image7.jpg",
    "revision": "2d01ef36da37d44b15d3e1eb834b6f7a"
  },
  {
    "url": "../../src/articleArchive/authorJeffCen/2013-05-04_LumberIsland/image1.jpg",
    "revision": "03fc72284cc485ed05301c8a2cdeb4f8"
  },
  {
    "url": "../../src/articleArchive/authorJeffCen/2013-05-20_1916/image1.jpg",
    "revision": "cc0320604793569b287ccfe3e18b4c0e"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2013-03-12_StarWarsBattlecry/image1.jpg",
    "revision": "944b6fed7d11b29767d411f899b0c1e5"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2013-03-12_StarWarsBattlecry/image10.jpg",
    "revision": "778423e7cfc195c8b1626bf1984028ab"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2013-03-12_StarWarsBattlecry/image2.jpg",
    "revision": "8e8cc2a279f6192368d5f63d2921e2c8"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2013-03-12_StarWarsBattlecry/image3.png",
    "revision": "13c45d9e45e0843af490c79bcf9112f0"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2013-03-12_StarWarsBattlecry/image4.jpg",
    "revision": "d6e0ac8d3aa958fe732e5b534678aeae"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2013-03-12_StarWarsBattlecry/image5.jpg",
    "revision": "81cd2ce7ac648624fbe5c4424bb40a3d"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2013-03-12_StarWarsBattlecry/image6.jpg",
    "revision": "eae6596f7285f37da79485b1d824ed06"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2013-03-12_StarWarsBattlecry/image7.jpg",
    "revision": "4d00ee9206e340f9bfc9c0e05fed9d70"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2013-03-12_StarWarsBattlecry/image8.png",
    "revision": "476d822555557c9f8e2e1a6ed84de333"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2013-03-12_StarWarsBattlecry/image9.jpg",
    "revision": "143c7ea554ad452f73f2158d54966ed1"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2013-04-20_TacticalIntervention/image1.jpg",
    "revision": "1b8b21d8fba9bb03f330668314e0f95b"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2013-04-20_TacticalIntervention/image2.jpg",
    "revision": "3edb75fac6e1d813ecc18f0e8d84e0dd"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2013-04-20_TacticalIntervention/image3.jpg",
    "revision": "2f1e067a37f38cf17addaed54aa3eaec"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2013-04-20_TacticalIntervention/image4.jpg",
    "revision": "4ad59209e2f3349e6d8f6081d4831d29"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2013-04-20_TacticalIntervention/image5.jpg",
    "revision": "1a1222807c32dcee8cdbbcec1c99d44b"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2013-04-20_TacticalIntervention/image6.jpg",
    "revision": "533564a28b630e01c9a43a47e5477b92"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2013-04-20_TacticalIntervention/image7.jpg",
    "revision": "3f4beba90e836f88ae2c72db4a77053e"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2013-04-20_TacticalIntervention/image8.jpg",
    "revision": "cccfb1ebb6076366b0e5387b0ae500bb"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2013-04-20_TacticalIntervention/image9.jpg",
    "revision": "74be12350f518e432092e2374c0817d5"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2013-05-01_TacticalInterventionReview/image1.jpg",
    "revision": "ffae8ecd36e9d6ac0958af44fe0ddf07"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2013-05-29_LittleSimPeeps/image1.png",
    "revision": "6c934e7f0a94ffb82e8ad03baf33ed27"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2013-05-29_LittleSimPeeps/image2.png",
    "revision": "a4789ea575c1f149db00fa3ae156ccca"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2013-05-29_LittleSimPeeps/image3.png",
    "revision": "720b110966f9540a073d9e84fe70c2ff"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2013-05-29_LittleSimPeeps/image4.png",
    "revision": "51cd3b9282c3a4f90cba36caf2c85881"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2013-05-29_LittleSimPeeps/image5.png",
    "revision": "13598a98df94dea6df498c0cf5069ec6"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2016-04-13_EarlyAccessPhantasmal/image1.jpg",
    "revision": "f644b028a35b8fc45c7eab17d1100eba"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2016-04-13_EarlyAccessPhantasmal/image2.jpg",
    "revision": "deab3e4abe15fab915f6000f5ce219e4"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2016-04-13_EarlyAccessPhantasmal/image3.webp",
    "revision": "ae3d05e54952d5200cba5a5c4ea586fb"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2016-04-15_HearthstoneDownWithTheSickness/image1.jpg",
    "revision": "9d67f1004f26a3b845913627125114cf"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2016-04-15_HearthstoneDownWithTheSickness/image2.jpg",
    "revision": "693448ee9dafbde1f187a4403df3b998"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2016-04-15_HearthstoneDownWithTheSickness/image2.webp",
    "revision": "b9c9933779ba81e26b7f061e7432c59d"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2016-04-15_HearthstoneDownWithTheSickness/image3.png",
    "revision": "3e214a4f1bcb8f6e39832eb5f0ee6c27"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2016-04-15_HearthstoneDownWithTheSickness/image4.jpg",
    "revision": "e93c1c4732d00472ce5b958b6eb32507"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2016-04-15_HearthstoneDownWithTheSickness/image5.jpg",
    "revision": "f6483f63aa45042b410fecd8412dbe4d"
  },
  {
    "url": "../../src/articleArchive/authorNeilRampone/2016-04-15_HearthstoneDownWithTheSickness/image6.png",
    "revision": "3e8ecc1d80e244b46a3608b1447d1cbd"
  },
  {
    "url": "../../src/icon/android-chrome-144x144.png",
    "revision": "150037da79b66c6b1626b0dc8ab18386"
  },
  {
    "url": "../../src/icon/android-chrome-192x192.png",
    "revision": "ebdb6848cccb1c3bb386a31bf2cd1198"
  },
  {
    "url": "../../src/icon/android-chrome-256x256.png",
    "revision": "3db24f6428860ef5b8710d164f2f7443"
  },
  {
    "url": "../../src/icon/android-chrome-36x36.png",
    "revision": "72ef8d40e86aa07babf1207fcfd508de"
  },
  {
    "url": "../../src/icon/android-chrome-384x384.png",
    "revision": "537beeb0ac092d0c03a1ae061f30f4df"
  },
  {
    "url": "../../src/icon/android-chrome-48x48.png",
    "revision": "e757907a4ea0fc34637a76f6bfaf35c3"
  },
  {
    "url": "../../src/icon/android-chrome-512x512.png",
    "revision": "f24bcc3facbb90204f74454b00276ac7"
  },
  {
    "url": "../../src/icon/android-chrome-72x72.png",
    "revision": "fea09f854fe850dc90c1265760a49655"
  },
  {
    "url": "../../src/icon/android-chrome-96x96.png",
    "revision": "a2325150e4c1a267c4b08686cde94ba9"
  },
  {
    "url": "../../src/icon/apple-touch-icon-114x114-precomposed.png",
    "revision": "023dddb9cb18efe77f040fefd3dcae3f"
  },
  {
    "url": "../../src/icon/apple-touch-icon-114x114.png",
    "revision": "e66b4caa7f9da868f059ce6d4e6519bf"
  },
  {
    "url": "../../src/icon/apple-touch-icon-120x120-precomposed.png",
    "revision": "af72d1d3873245e10be8aba73c29ff62"
  },
  {
    "url": "../../src/icon/apple-touch-icon-120x120.png",
    "revision": "2387233207d780cdf09c918e31d5b7e1"
  },
  {
    "url": "../../src/icon/apple-touch-icon-144x144-precomposed.png",
    "revision": "6d16b423cb74b8f7aaece4b8281122d8"
  },
  {
    "url": "../../src/icon/apple-touch-icon-144x144.png",
    "revision": "495240ff6c9fe75a63d5feb349e3c925"
  },
  {
    "url": "../../src/icon/apple-touch-icon-152x152-precomposed.png",
    "revision": "c895db198ec31d6abb68b4f158276257"
  },
  {
    "url": "../../src/icon/apple-touch-icon-152x152.png",
    "revision": "62accd49fd6e3d7abb3ca0f8947565bd"
  },
  {
    "url": "../../src/icon/apple-touch-icon-180x180-precomposed.png",
    "revision": "37de2dc46db6e1cd270c7104ae17493d"
  },
  {
    "url": "../../src/icon/apple-touch-icon-180x180.png",
    "revision": "6aeda0af32228fc4dae14b08af5b93e8"
  },
  {
    "url": "../../src/icon/apple-touch-icon-57x57-precomposed.png",
    "revision": "a9b848e76c7842800e167fcd5b3f7cac"
  },
  {
    "url": "../../src/icon/apple-touch-icon-57x57.png",
    "revision": "9b7f6f2dfbcfc843d5764e8b1253dcfb"
  },
  {
    "url": "../../src/icon/apple-touch-icon-60x60-precomposed.png",
    "revision": "994c65076e69863ec0492dda9dded823"
  },
  {
    "url": "../../src/icon/apple-touch-icon-60x60.png",
    "revision": "187f7e918dee18f9e94f2bbe57d23ccf"
  },
  {
    "url": "../../src/icon/apple-touch-icon-72x72-precomposed.png",
    "revision": "81ac10bdafbf041740d1cd727dc6eade"
  },
  {
    "url": "../../src/icon/apple-touch-icon-72x72.png",
    "revision": "9fbcc7caa5a7ea24fb4ac207dbfb8ba9"
  },
  {
    "url": "../../src/icon/apple-touch-icon-76x76-precomposed.png",
    "revision": "9a244bf4222ec9f9e07be19ba2b2cc0d"
  },
  {
    "url": "../../src/icon/apple-touch-icon-76x76.png",
    "revision": "896f3494bde7403518c8f77a909d50d5"
  },
  {
    "url": "../../src/icon/apple-touch-icon-precomposed.png",
    "revision": "37de2dc46db6e1cd270c7104ae17493d"
  },
  {
    "url": "../../src/icon/apple-touch-icon.png",
    "revision": "6aeda0af32228fc4dae14b08af5b93e8"
  },
  {
    "url": "../../src/icon/browserconfig.xml",
    "revision": "f8aeededd5ff4e020707d2d1937834fa"
  },
  {
    "url": "../../src/icon/favicon-16x16.png",
    "revision": "521b6c7a85040303c452574186f4aaa7"
  },
  {
    "url": "../../src/icon/favicon-32x32.png",
    "revision": "abc3b2c04d387b15b6a095e4d57607f1"
  },
  {
    "url": "../../src/icon/favicon.ico",
    "revision": "fdb418cff9de0070a0171eac6524fa7f"
  },
  {
    "url": "../../src/icon/maskable_icon_x128.png",
    "revision": "0cf5907a0d6a387ee3efbcf7f75f5833"
  },
  {
    "url": "../../src/icon/maskable_icon_x192.png",
    "revision": "cd008a7876521e106a8ce3d879d4bb0d"
  },
  {
    "url": "../../src/icon/maskable_icon_x384.png",
    "revision": "b631fd915cdba817285cfc8388c4c27d"
  },
  {
    "url": "../../src/icon/maskable_icon_x48.png",
    "revision": "8c90175e38a2bacc4f440b2802419658"
  },
  {
    "url": "../../src/icon/maskable_icon_x512.png",
    "revision": "d39afa45bb3e2db10c1e8d2069fe2c02"
  },
  {
    "url": "../../src/icon/maskable_icon_x72.png",
    "revision": "4acb0a9221c010a73817631b71df2373"
  },
  {
    "url": "../../src/icon/maskable_icon_x96.png",
    "revision": "6e8aaada301b3a092a0b2a3424108867"
  },
  {
    "url": "../../src/icon/maskable_icon.png",
    "revision": "70323e1764adc77e65ec31dd127bf863"
  },
  {
    "url": "../../src/icon/mstile-144x144.png",
    "revision": "150037da79b66c6b1626b0dc8ab18386"
  },
  {
    "url": "../../src/icon/mstile-150x150.png",
    "revision": "23e0a94aac4c64ac81218346e47f357f"
  },
  {
    "url": "../../src/icon/mstile-310x150.png",
    "revision": "fdcc061e92851d4bb2424d44f14a330b"
  },
  {
    "url": "../../src/icon/mstile-310x310.png",
    "revision": "219233365848720bfbe14df7ddedbec3"
  },
  {
    "url": "../../src/icon/mstile-70x70.png",
    "revision": "0766ea016338863db2d6091d26b0248a"
  },
  {
    "url": "../../src/icon/resoc.png",
    "revision": "09ef507b07d8762342ab8bd0edb8f575"
  },
  {
    "url": "../../src/icon/safari-pinned-tab.svg",
    "revision": "e41d676b428a9436096866226937e5bb"
  },
  {
    "url": "../../src/icon/screenshot1.webp",
    "revision": "208af10afc13a402fbb8fd381f450a8b"
  },
  {
    "url": "../../src/icon/screenshot2.webp",
    "revision": "b11308dba17a28992ca8882d779c6485"
  },
  {
    "url": "../../src/icon/screenshot3.webp",
    "revision": "0a43570feda9a66c609945ed90756873"
  },
  {
    "url": "../../src/icon/site.webmanifest",
    "revision": "02f9258b2fe359e54c7059a84e9f6e6e"
  },
  {
    "url": "../../src/images/COMING_SOON.svg",
    "revision": "cc6507cf09df32f597ec080eb0165cb7"
  },
  {
    "url": "../../src/images/divider.gif",
    "revision": "8dd0e40f42389ca295f0c9408e28c22c"
  },
  {
    "url": "../../src/images/logo.svg",
    "revision": "90d8d81f1c27b6742d4b02be5f18938f"
  },
  {
    "url": "../../src/images/shade.png",
    "revision": "63692a2b6c9a9203e8ade8aa43b9f91e"
  },
  {
    "url": "../../src/images/title.svg",
    "revision": "ff76ce5a407379874b947d96258c734a"
  },
  {
    "url": "../../src/legacyPages/legacyPagesDisplay.json",
    "revision": "df3c40abc3a40b19482a57c0a9917e65"
  },
  {
    "url": "../../src/scripts/index.js",
    "revision": "e39f81daa61b6543736645ab6985a956"
  },
  {
    "url": "../../src/scripts/index.min.js",
    "revision": "0955e521711960f8fca0af8976b5d811"
  },
  {
    "url": "../../src/scripts/index.test.js",
    "revision": "354e5414e743dec212647ea1850b6178"
  },
  {
    "url": "../../src/scripts/libraries/bootstrap/css/bootstrap-grid.css",
    "revision": "e0f29b48cdc586df96b3a3803f49a13c"
  },
  {
    "url": "../../src/scripts/libraries/bootstrap/css/bootstrap-grid.min.css",
    "revision": "16099f86d058b2b38b54eba53cf3aecd"
  },
  {
    "url": "../../src/scripts/libraries/bootstrap/css/bootstrap-grid.rtl.css",
    "revision": "43d5a49ff8855a46a33d7ebf6837e077"
  },
  {
    "url": "../../src/scripts/libraries/bootstrap/css/bootstrap-grid.rtl.min.css",
    "revision": "416c0d373e7f11bc3454aa0be9199290"
  },
  {
    "url": "../../src/scripts/libraries/bootstrap/css/bootstrap-reboot.css",
    "revision": "2fba64635ebe7311faf01c0c24d1111c"
  },
  {
    "url": "../../src/scripts/libraries/bootstrap/css/bootstrap-reboot.min.css",
    "revision": "08bb021af55f4704dd873b55051f48f5"
  },
  {
    "url": "../../src/scripts/libraries/bootstrap/css/bootstrap-reboot.rtl.css",
    "revision": "9ee45a422f26f85b28e095b9b5e182ad"
  },
  {
    "url": "../../src/scripts/libraries/bootstrap/css/bootstrap-reboot.rtl.min.css",
    "revision": "1416aec2e379161a1d4c25932976e347"
  },
  {
    "url": "../../src/scripts/libraries/bootstrap/css/bootstrap-utilities.css",
    "revision": "0f8a621d1bb820cdc5d85790ee45cbcc"
  },
  {
    "url": "../../src/scripts/libraries/bootstrap/css/bootstrap-utilities.min.css",
    "revision": "e9a1b7e10c32c2783294947495434b6f"
  },
  {
    "url": "../../src/scripts/libraries/bootstrap/css/bootstrap-utilities.rtl.css",
    "revision": "b03ce607fce6ef7072d6bae8c6dcb8cb"
  },
  {
    "url": "../../src/scripts/libraries/bootstrap/css/bootstrap-utilities.rtl.min.css",
    "revision": "21c5275dd13ec55e2c59cd105ad173b2"
  },
  {
    "url": "../../src/scripts/libraries/bootstrap/css/bootstrap.css",
    "revision": "0c6188f6ee60224a5393ad267534cf10"
  },
  {
    "url": "../../src/scripts/libraries/bootstrap/css/bootstrap.min.css",
    "revision": "50c95aae1a6c1e089c11681d1e1906f8"
  },
  {
    "url": "../../src/scripts/libraries/bootstrap/css/bootstrap.rtl.css",
    "revision": "c5080a94bed58cd4fd5e7bd928072e9e"
  },
  {
    "url": "../../src/scripts/libraries/bootstrap/css/bootstrap.rtl.min.css",
    "revision": "d3d3d6b180a5e55fc03c2de7ee6c18c1"
  },
  {
    "url": "../../src/scripts/libraries/bootstrap/js/bootstrap.bundle.js",
    "revision": "8c2fbb71d14f4b2a0e9dca4ab492fd2b"
  },
  {
    "url": "../../src/scripts/libraries/bootstrap/js/bootstrap.bundle.min.js",
    "revision": "21d4551af5cc4ed4d818bdbdfea8c358"
  },
  {
    "url": "../../src/scripts/libraries/bootstrap/js/bootstrap.esm.js",
    "revision": "c7da859365f44dde0228933507ef8784"
  },
  {
    "url": "../../src/scripts/libraries/bootstrap/js/bootstrap.esm.min.js",
    "revision": "4929c0335084f6fedf91fbbcf57f93f3"
  },
  {
    "url": "../../src/scripts/libraries/bootstrap/js/bootstrap.js",
    "revision": "24b695f97e87f5693850430d4b068d3d"
  },
  {
    "url": "../../src/scripts/libraries/bootstrap/js/bootstrap.min.js",
    "revision": "20780829333b37d19f72573fddec1bbe"
  },
  {
    "url": "../../src/scripts/libraries/jquery/jquery.min.js",
    "revision": "c9771cc3e90e18f5336eedbd0fffb2cf"
  },
  {
    "url": "../../src/scripts/libraries/showdown/showdown.min.js",
    "revision": "14517f70ed205ae583be682c9157ebe9"
  },
  {
    "url": "../../src/style.css",
    "revision": "c4dce33b7dd1433eab1ee30e7797016f"
  },
  {
    "url": "../../src/style.min.css",
    "revision": "2241894855fc1e471f4f23e28aed8f62"
  }
], {});




workbox_routing_registerRoute(/\.(?:png|jpg|jpeg|webp|ico|svg)$/, new workbox_strategies_CacheFirst({ "cacheName":"images", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 10 })] }), 'GET');




